const DFT = (points) => {
  const N = Object.keys(points).length;
  const X = [];
  for (let k = 0; k < N; k++) {
    let re = 0;
    let im = 0;
    for (let n = 0; n < N; n++) {
      const x = points[n] || 0;
      const phi = (2 * Math.PI * k * n) / N;
      re += x * Math.cos(phi);
      im -= x * Math.sin(phi);
    }
    re /= N;
    im /= N;
    const freq = k;
    const amplitude = Math.sqrt(re * re + im * im);
    const phase = Math.atan2(im, re);
    X.push({ re, im, freq, amplitude, phase });
  }
  return X;
};
export default DFT;